<template>
    <span class="expiration-time">
        <base-smart-countdown
            :time-stamp="currentPurchasedExpirationTime"
            @onTimeEnds="onExpirationTime"
            hide-days
            hide-hours
        >
        </base-smart-countdown>
    </span>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseSmartCountdown from '@RepoComponent/BaseSmartCountdown/BaseSmartCountdown';
export default {
    name: 'ExpirationTime',

    props: {
        voiceUniqueId: {
            type: String,
            required: true,
        },
    },
    components: {
        BaseSmartCountdown,
    },

    computed: {
        ...mapGetters({
            get_purchasedVoice: 'panel/get_purchasedVoice',
        }),

        currentPurchasedExpirationTime() {
            return this.get_purchasedVoice(this.voiceUniqueId)?.expireAt || new Date().getTime();
        },
    },

    methods: {
        ...mapActions({
            axn_expireVoice: 'panel/axn_expireVoice',
        }),

        onExpirationTime() {
            this.axn_expireVoice(this.voiceUniqueId);
        },
    },
};
</script>

<style lang="scss" src="./ExpirationTime.scss"></style>
